"use client";

import { cn } from "@/lib/utils";
import { RUN_DOT_CLASS, type WeekDotState } from "./WeekDots";
export interface DockPeekRow {
  key: string;
  /** When it runs, already formatted: "9:00 AM". */
  time: string;
  title: string;
  state: Exclude<WeekDotState, "off">;
  /** How it went, read out for the dot: "Didn't finish". */
  stateLabel: string;
}

/**
 * The glance a dock app gives on hover: a short list of what it holds today,
 * one line each with a time, a round dot and a name. Read-only; choosing the
 * app opens it.
 */
export function DockPeek({
  label,
  rows,
  emptyLabel,
  moreLabel,
  className
}: {
  /** What the list is, as its accessible name. */
  label: string;
  rows: DockPeekRow[];
  emptyLabel: string;
  /** Shown under the rows when more were left out: "3 more". */
  moreLabel?: string;
  className?: string;
}) {
  return <div role="group" aria-label={label} className={cn("w-64 rounded-card bg-surface p-1.5 text-left shadow-float", "animate-in fade-in-0 slide-in-from-bottom-1 duration-base", className)} data-sentry-component="DockPeek" data-sentry-source-file="DockPeek.tsx">
            {rows.length === 0 ? <p className="m-0 px-2.5 py-2 text-callout text-ink-2">
                    {emptyLabel}
                </p> : <ul className="m-0 flex list-none flex-col p-0">
                    {rows.map(row => <li key={row.key} className="flex h-8 items-center gap-2.5 px-2.5 text-callout">
                            <span className="w-16 shrink-0 whitespace-nowrap font-mono text-footnote tabular-nums text-ink-3">
                                {row.time}
                            </span>
                            <span role="img" aria-label={row.stateLabel} title={row.stateLabel} className={cn("h-2 w-2 shrink-0 rounded-full", RUN_DOT_CLASS[row.state])} />
                            <span className="min-w-0 truncate text-ink">
                                {row.title}
                            </span>
                        </li>)}
                </ul>}
            {moreLabel && <p className="m-0 px-2.5 pb-1.5 pt-1 text-footnote text-ink-3">
                    {moreLabel}
                </p>}
        </div>;
}